import React from 'react';

const FloatingIcons: React.FC = () => {
  const icons = [
    'fa-brain',
    'fa-robot',
    'fa-code',
    'fa-microchip'
  ];

  return (
    <div className="floating-icons">
      {icons.map((icon, index) => (
        <i key={index} className={`fas ${icon} floating-icon`}></i>
      ))}
    </div>
  );
};

export default FloatingIcons; 